var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      staticClass: "mt-3 main-snackbar",
      attrs: {
        top: "",
        color: _vm.color,
        timeout: _vm.timeOut,
        "auto-height": "",
      },
      model: {
        value: _vm.showSnackBar,
        callback: function ($$v) {
          _vm.showSnackBar = $$v
        },
        expression: "showSnackBar",
      },
    },
    [
      _vm.icon
        ? _c("v-icon", { staticClass: "mr-2", attrs: { color: "white" } }, [
            _vm._v(_vm._s(_vm.icon)),
          ])
        : _vm._e(),
      _vm._v("\n  " + _vm._s(_vm.message) + "\n  "),
      _c(
        "v-btn",
        {
          attrs: { flat: "" },
          on: {
            click: function ($event) {
              _vm.showSnackBar = false
            },
          },
        },
        [_vm._v("Close")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }